import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ViewEncapsulation,
  ChangeDetectorRef,
  NO_ERRORS_SCHEMA,
} from '@angular/core'
import { UserStateType } from 'src/app/core/services/user-state.service'
import { ModalPopupsService } from '../../modal-popups.service'

@Component({
    selector: 'app-invalid-state-popup',
    templateUrl: './invalid-state.component.html',
    styleUrls: ['./invalid-state.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class InvalidStatePopupComponent implements OnInit {
  constructor(private cdr: ChangeDetectorRef, public modalPopups: ModalPopupsService) {}

  @Input() additionalClasses = ''
  @Input() isMobile = false
  @Input() isBlocked = false
  @Input() amountValue: string = '$0.00'
  @Input() type: UserStateType = UserStateType.state
  @Output() toggleLoader: EventEmitter<any> = new EventEmitter()
  @Output() closed: EventEmitter<unknown> = new EventEmitter()

  _UserStateType = UserStateType

  typeIs(is: UserStateType) {
    return is === this.type
  }

  close() {
    this.closed.emit(true)
  }

  // isInvalidAmount(){
  //   return this.typeIs(this._UserStateType.preApproved) || this.typeIs(this._UserStateType.lessStateAmountAfter) || this.typeIs(this._UserStateType.minRequiredAmount)
  // }

  ngOnInit(): void {
    this.toggleLoader.emit(false)
    this.cdr.detectChanges()
  }
}
